export const MAX_FILE_SIZE = 31457280

export const fileuploadErrors = {
  FILE_SIZE: 'Max file size is 30 MB',
  FILE_TYPE: 'File type not accepted.',
  FILE_NAME: 'File name cannot contain any of these characters: < > : |',
}
